<template>
  <div id="scheme" class="networkshops-scheme">
    <div class="networkshops-scheme-grid">
      <div class="shipping-types-block-grid-main">
        <img src="/svg/gears.svg" class="svg-white" alt="">
        <div>
          <h3 v-html="title" />
          <p class="fs-18 text-transform-none pr-10 pt-10" style="font-weight: normal">
            {{ description }}
          </p>
        </div>
      </div>
      <public-info-grid-block
        v-for="(item, i) of items"
        :item="item"
        :listId="i + 1"
        :key="i"
        rounded-style
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PublicInfoGridBlock from '~/components/public/public-info-grid-block.vue';

const props = defineProps({
  isMarketplaces: {
    type: Boolean,
    default: false
  }
})

const data = {
  attention: 'Услуга не оказывается при заборе по адресу',
  itemText_1: 'Воспользуйтесь удобным калькулятором доставки для  включает следующие этапы и торговых сетей, указав нужное направление и даты.',
  itemText_2: 'Сделайте заказ на сайте, в личном кабинете Vozovoz или по телефону горячей линии.',
  itemText_3: 'Проведите необходимую подготовку груза к доставке с учетом описанных требований. Упакуйте товар самостоятельно или воспользуйтесь услугами упаковки на терминале.',
  itemText_4: 'Проверим ваш груз на соответствие требованиям сети перед осуществлением доставки. В случае выявления несоответствий, уведомим об этом и окажем дополнительные услуги по финальной подготовке груза к приёмке.',
  itemText_5: 'Передайте груз на любой из терминалов Vozovoz самостоятельно или воспользуйтесь услугой забора с адреса.',
  itemText_6: 'Оплатите перевозку удобным способом: банковской картой, безналично, по QR-коду или через один из платёжных терминалов Элекснет и ПСКБ.',
  itemText_7: 'В случае, если водителю потребуется пропуск на территорию склада запросите данные для его оформления при заказе. Вся необходимая информация будет направлена на указанный электронный адрес за сутки до доставки груза до маркетплейсов.',
  itemText_8: 'Организуйте получение груза на складе в согласованный для доставки временной промежуток.',
  itemText_9: 'Запросите необходимые документы в форме отслеживания груза на сайте или по телефону горячей линии. Также электронные копии документов доступны при регистрации полного доступа к контрагенту в личном кабинете Vozovoz.',
  itemTitle_1: 'Расчёт стоимости перевозки',
  itemTitle_2: 'Оформление заявки на перевозку',
  itemTitle_3: 'Подготовка груза',
  itemTitle_4: 'Проверка груза',
  itemTitle_5: 'Забор или сдача груза',
  itemTitle_6: 'Оплата перевозки',
  itemTitle_7: 'Оформление пропуска для водителя',
  itemTitle_8: 'Доставка на склад',
  itemTitle_9: 'Получение документов по перевозке',
}

const title = computed(() => {
  return  props.isMarketplaces 
    ? 'Процесс<br/> доставки грузов'
    : 'Схема<br/> доставки товаров'
})

const description = computed(() => {
  return `на склады ${props.isMarketplaces ? 'маркетплейсов' : 'торговых сетей и сетевых магазинов' } включает следующие этапы:`
})

const items = computed(() => [
  {
    icon: {
      name: 'account'
    },
    title: data.itemTitle_1,
    text: data.itemText_1,
  },
  {
    icon: {
      url: '/svg/vz-phone-success-2.svg'
    },
    title: data.itemTitle_2,
    text: data.itemText_2,
  },
  {
    icon: {
      url: '/svg/phone-in-talk.svg'
    },
    title: data.itemTitle_3,
    text: data.itemText_3,
    warning: data.attention,
  },
  {
    icon: {
      url: '/svg/vz-signature.svg'
    },
    title: data.itemTitle_4,
    text: data.itemText_4,
    warning: 'Услуга доступна для Wildberries',
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    link: {
      title: 'Подробнее об услуге',
      to: {
        name: 'address-delivery'
      }
    },
    title: data.itemTitle_5,
    text: data.itemText_5,
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    link: {
      title: 'Подробнее о способах оплаты',
      to: {
        name: 'payment-methods'
      }
    },
    title: data.itemTitle_6,
    text: data.itemText_6,
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    title: data.itemTitle_7,
    text: data.itemText_7,
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    title: data.itemTitle_8,
    text: data.itemText_8,
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    link: {
      title: 'Подробнее о возможностях личного кабинета',
      to: {
        name: 'guide-lk'
      }
    },
    title: data.itemTitle_9,
    text: data.itemText_9,
  },
])
</script>

<style scoped lang="scss">
.networkshops-scheme {
  .shipping-types-block-grid-main {
    text-align: left;
    align-items: flex-start;
    padding: 40px;
  }

  h3 {
    margin-bottom: 10px;
  }

  &-grid {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(6, 1fr);
  }


  @media screen and (min-width: $pub-sm + 1) {
    &-grid {
      margin: 70px auto;
      grid-template-columns: repeat(12, 1fr);
      gap: 20px;
      > div {
        &:nth-child(1) {
          grid-area: 1 / 1 / 3 / 5;
        }
        &:nth-child(2) {
          grid-area: 1 / 5 / 1 / 9;
        }
        &:nth-child(3) {
          grid-area: 1 / 9 / 1 / 13;
        }
        &:nth-child(4) {
          grid-area: 2 / 5 / 2 / 13;
        }
        &:nth-child(5) {
          grid-area: 3 / 1 / 3 / 8;
        }
        &:nth-child(6) {
          grid-area: 3 / 8 / 3 / 13;
        }
        &:nth-child(7) {
          grid-area: 4 / 1 / 4 / 7;
        }
        &:nth-child(8) {
          grid-area: 4 / 7 / 4 / 13;
        }
        &:nth-child(9) {
          grid-area: 5 / 1 / 5 / 6;
        }
        &:nth-child(10) {
          grid-area: 5 / 6 / 5 / 13;
        }
      }
    }
  }

  @media screen and (max-width: $pub-sm) {
    .shipping-types-block-grid-main {
      padding: 30px;
    }
    &-grid {
      margin: 70px auto;
      grid-template-columns: repeat(12, 1fr);
      > div {
        &:nth-child(1) {
          grid-area: 1 / 1 / 4 / 5;
        }
        &:nth-child(2) {
          grid-area: 1 / 5 / 1 / 13;
        }
        &:nth-child(3) {
          grid-area: 2 / 5 / 2 / 13;
        }
        &:nth-child(4) {
          grid-area: 3 / 5 / 3 / 13;
        }
        &:nth-child(5) {
          grid-area: 4 / 1 / 4 / 13;
        }
        &:nth-child(6) {
          grid-area: 5 / 1 / 5 / 6;
        }
        &:nth-child(7) {
          grid-area: 5 / 6 / 5 / 13;
        }
        &:nth-child(8) {
          grid-area: 6 / 1 / 6 / 13;
        }
        &:nth-child(9) {
          grid-area: 7 / 1 / 7 / 13;
        }
        &:nth-child(10) {
          grid-area: 8 / 1 / 8 / 13;
        }
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-grid {
      margin: 40px auto;
      grid-template-columns: 1fr;
      > div {
        grid-area: unset !important;
        grid-column-start: 1;
        grid-column-end: 2;
      }
    }
  }
}
</style>
